export const TRIAL_DEFAULT = 'TRIAL_DEFAULT';
